import PasswordComponent from "components/passwordComponent/PasswordComponent";

function Password() {
  return (
    <div>
      <PasswordComponent />
    </div>
  );
}

export default Password;
